// Internal articles hosted on the website
// These appear in "In the News" but link to pages on our site

export const articles = [
  {
    id: 'tokyo-meets-port-vila-kakigori',
    title: 'When Tokyo Met Port Vila: Kakigori, Rum, and the Spirit of Finding a Way',
    publication: '83 Islands Distillery',
    date: '2026-05-21',
    author: '83 Islands Distillery',
    location: 'Port Vila, Vanuatu',
    heroImage: '/image/articles/kakigori-rum-finish.jpg',
    lead: 'On 19 May, 83 Islands Distillery welcomed Mr. Yoshinori Nishigaya, CEO and Kakigori Producer of Vinefru Ginza in Tokyo, for a very special kakigori tasting in Port Vila — and discovered just how naturally Japanese shaved ice, island ingredients, and 83 Islands rum belong together at the edge of the Pacific.',
    content: [
      {
        heading: '',
        paragraphs: [
          'On 19 May, 83 Islands Distillery had the honour of welcoming Mr. Yoshinori Nishigaya, CEO and Kakigori Producer of Vinefru Ginza in Tokyo, for a very special Kakigori tasting at our distillery in Port Vila.'
        ],
        image: {
          url: '/image/articles/kakigori-tasting-guests.jpg',
          alt: 'Guests gathered at the 83 Islands Distillery bar watching kakigori being prepared',
          caption: 'Around 30 guests joined us at the distillery to discover Japanese-style shaved ice, prepared by a master.'
        }
      },
      {
        heading: 'A Master\'s Craft',
        paragraphs: [
          'Kakigori is Japanese-style shaved ice: delicate, refreshing, and incredibly expressive when prepared by a master. In Japan, it is much more than crushed ice and syrup. At its best, it is a balance of texture, temperature, flavour, and presentation — a dish that feels simple at first glance, yet reveals great precision in every detail.',
          'Mr. Nishigaya brought that precision to Vanuatu, creating a series of Kakigori topped with rich, fluffy mousse sauces made from a variety of ingredients. Each creation had its own personality: light, cold, generous, and beautifully layered. Around 30 guests joined us for the tasting, discovering a dish that feels at once deeply Japanese and perfectly suited to the tropical rhythm of Vanuatu.'
        ],
        images: [
          {
            url: '/image/articles/kakigori-nishigaya-technique.jpg',
            alt: 'Mr. Yoshinori Nishigaya preparing kakigori at the 83 Islands Distillery bar',
            caption: 'Mr. Yoshinori Nishigaya of Vinefru Ginza at work — every detail of kakigori reveals great precision.'
          },
          {
            url: '/image/articles/kakigori-bowls-prepared.jpg',
            alt: 'Bowls of finely shaved ice topped with mousse sauces',
            caption: 'A series of kakigori, each finished with a rich, fluffy mousse sauce.'
          }
        ]
      },
      {
        heading: 'A First for All of Us',
        paragraphs: [
          'For Mr. Nishigaya, this was his first visit to the Pacific, despite having demonstrated Kakigori in many countries around the world. We were proud that Vanuatu, and 83 Islands, could be part of that journey.',
          'For us, this event was also a first step. We worked with the ingredients available to us and without all the specialist equipment normally used to create Kakigori at this level. But that is often how things begin in Vanuatu: you adapt, you learn, and you find a way.',
          'And what we discovered was exciting.'
        ]
      },
      {
        heading: 'A Natural Fit for the Tropics',
        paragraphs: [
          'Kakigori is a superb fit for a tropical environment. It is light, cold, elegant, and refreshing — exactly the kind of dish that makes sense under the Port Vila sun. Enjoyed alcohol-free, it is already a beautiful experience: delicate, cooling, and full of texture. But when you add 83 Islands Rum, it becomes something else entirely.',
          'The contrast is what makes it special. The ice brings freshness. The mousse brings softness and body. The flavours unfold slowly as the dish melts. Then the rum adds warmth, depth, aroma, and structure. It becomes cold and warm, delicate and deep, Japanese technique meeting the wild spirit of Vanuatu.'
        ],
        image: {
          url: '/image/articles/kakigori-rum-finish.jpg',
          alt: 'Kakigori topped with berries being finished with 83 Islands rum',
          caption: 'Add 83 Islands Rum and kakigori becomes something else entirely — cold and warm, delicate and deep.'
        }
      },
      {
        heading: 'A New Canvas',
        paragraphs: [
          'This is what interests us most. Kakigori gives us a new canvas to explore local fruits, island ingredients, tropical flavours, and our own rum in a way that feels unexpected, but completely natural here. It can be served alcohol-free and enjoyed by everyone, or transformed with rum into a more layered tasting experience.',
          'Kakigori is a beautifully accessible dish, but like many simple things, the details matter. Our first trial showed us the importance of having the right tools, especially to create the light whipped covering that helps protect the ice and gives Kakigori its signature finish. Over the next few weeks, we will bring in what is needed to serve it regularly at 83 Islands, with the hope that other shops in town may also embrace this affordable, refreshing dish that suits Vanuatu so perfectly.'
        ]
      },
      {
        heading: 'Honouring, Not Copying',
        paragraphs: [
          'Our aim is not to copy Japan, but to honour what we learned from Mr. Nishigaya and translate it through our own place: our climate, our ingredients, our hospitality, and our way of making things work at the edge of the Pacific. Just as our rum is shaped by Vanuatu\'s sugarcane, heat, rain, and patience, our Kakigori will be shaped by the islands around us.'
        ]
      },
      {
        heading: 'With Thanks',
        paragraphs: [
          'A heartfelt thank you to Mr. Yoshinori Nishigaya and Vinefru Ginza for sharing the art of Kakigori with us, to Ms. Mai from GnR Co., Ltd., our Japanese distributor, for helping make this connection possible, and to First Secretary Toshikazu Nohara and the Embassy of Japan in Vanuatu for joining us and supporting this meaningful moment of exchange between Japan and Vanuatu.',
          'This event was a small but beautiful symbol of growing people-to-people and business ties between Japan and Vanuatu. It brought together craft, curiosity, hospitality, and the simple pleasure of sharing something new.',
          'At 83 Islands, we have always believed that great ideas do not need to arrive fully formed. Sometimes they begin with a conversation. Sometimes with a visitor from far away. Sometimes with a bowl of shaved ice melting slowly in the tropical air.',
          'Kakigori is coming to 83 Islands — island style, rum optional, experience guaranteed.'
        ],
        image: {
          url: '/image/articles/kakigori-presented.jpg',
          alt: 'Two finished kakigori creations presented at 83 Islands Distillery',
          caption: 'Kakigori is coming to 83 Islands — island style, rum optional, experience guaranteed.'
        }
      }
    ],
    pressRelease: {
      forImmediateRelease: true,
      contactName: 'Pierre-Luc Chabot',
      contactEmail: 'contact@83islands.com',
      boilerplate: '83 Islands Distillery is Vanuatu\'s first craft rum distillery, founded in Port Vila. The distillery produces single-origin rum from Vanuatu\'s ancestral sugarcane varieties, grown in volcanic soil and harvested fresh for fermentation. Using traditional copper pot still distillation and tropical ageing, 83 Islands creates spirits that capture the true character of the Pacific islands.'
    }
  },
  {
    id: 'vinefru-kakigori',
    title: 'Tokyo\'s Famous Kakigori Shaved Ice Comes to 83 Islands Distillery for One Day Only',
    publication: '83 Islands Distillery',
    date: '2026-05-19',
    author: '83 Islands Distillery',
    location: 'Port Vila, Vanuatu',
    heroImage: '/image/articles/vinefru-kakigori-event.png',
    lead: '83 Islands Distillery welcomes Vinefru Ginza, one of Tokyo\'s most talked-about kakigori shaved ice shops, for a special one-day event in Port Vila on May 19, 2026 — including a workshop for local hospitality professionals.',
    content: [
      {
        heading: '',
        paragraphs: [
          '83 Islands Distillery is pleased to welcome Vinefru Ginza, one of Tokyo\'s most talked-about kakigori shaved ice shops, for a special one-day event in Port Vila.',
          'In Tokyo, Vinefru is known for attracting long queues, with customers sometimes waiting up to two hours to enjoy its refined Japanese shaved ice creations. On May 19, guests in Vanuatu will have a rare opportunity to experience this celebrated Japanese food tradition at 83 Islands Distillery.'
        ]
      },
      {
        heading: 'More Than Ordinary Shaved Ice',
        paragraphs: [
          'Kakigori is much more than ordinary shaved ice. It is a delicate Japanese dessert made with finely shaved ice and carefully prepared toppings, often combining fruit, cream, syrups, and other refined flavours. This event will offer a unique opportunity to discover a prized Tokyo delicacy in a tropical Vanuatu setting.'
        ]
      },
      {
        heading: 'A Workshop for Local Hospitality',
        paragraphs: [
          'The visit will also include a workshop for local bars and restaurants, giving chefs, bartenders, and hospitality professionals the chance to learn more about how kakigori is prepared, presented, and served. For the local hospitality industry, this is a valuable opportunity to explore a popular Japanese food experience that could inspire new ideas for menus, desserts, and bar offerings.'
        ]
      },
      {
        heading: 'Event Details',
        paragraphs: [
          'The event will take place at 83 Islands Distillery in Port Vila on May 19 only.',
          'Date: May 19, 2026',
          'Location: 83 Islands Distillery, Port Vila',
          'Duration: One day only',
          'Featuring: Vinefru Ginza, Tokyo kakigori shaved ice',
          'We look forward to welcoming guests for this special celebration of Japanese food, culture, and hospitality in Vanuatu.'
        ]
      }
    ],
    pressRelease: {
      forImmediateRelease: true,
      contactName: 'Pierre-Luc Chabot',
      contactEmail: 'contact@83islands.com',
      boilerplate: '83 Islands Distillery is Vanuatu\'s first craft rum distillery, founded in Port Vila. The distillery produces single-origin rum from Vanuatu\'s ancestral sugarcane varieties, grown in volcanic soil and harvested fresh for fermentation. Using traditional copper pot still distillation and tropical ageing, 83 Islands creates spirits that capture the true character of the Pacific islands.'
    }
  },
  {
    id: 'faea-kava-relaunch',
    title: 'World First: 83 Islands Distillery Launches Faea Kava Spiced Rum',
    publication: '83 Islands Distillery',
    date: '2025-12-16',
    author: '83 Islands Distillery',
    location: 'Port Vila, Vanuatu',
    heroImage: '/image/83islands-faeakava.jpg',
    lead: 'Vanuatu\'s 83 Islands Distillery unveils a world-first spirit that combines noble kava and chilli with aged rum, showcasing the Pacific island nation\'s most distinctive ingredients in one groundbreaking release.',
    content: [
      {
        heading: '',
        paragraphs: [
          '83 Islands Distillery, Vanuatu\'s first craft rum distillery, has released Faea Kava Spiced Rum — a world-first spirit that brings together the Pacific\'s most distinctive flavours in a single bottle. After years of development and refinement, this groundbreaking release combines noble kava, locally grown habanero chilli, and aged rum to create a spirit unlike anything else on the market.',
          'The name "Faea" (pronounced fay-ah) comes from Bislama, Vanuatu\'s national language, meaning "fire" — a fitting tribute to both the volcanic origins of these islands and the spirit\'s gentle warmth.'
        ]
      },
      {
        heading: 'From Experiment to Excellence',
        paragraphs: [
          'The journey to Faea began several years ago when 83 Islands released a limited run of just 100 bottles featuring kava-infused rum. The response was overwhelming — customers loved it, and the bottles sold out quickly. But the distillery team knew they could do better.',
          '"We received incredible feedback from that first release, but we weren\'t satisfied with the process," explains Pierre-Luc Chabot, co-founder of 83 Islands Distillery. "We spent years perfecting every aspect of the extraction and infusion to create something truly exceptional."'
        ],
        quote: {
          text: 'We received incredible feedback from that first release, but we weren\'t satisfied with the process. We spent years perfecting every aspect of the extraction and infusion to create something truly exceptional.',
          attribution: 'Pierre-Luc Chabot, Co-Founder, 83 Islands Distillery'
        }
      },
      {
        heading: 'A Refined Process',
        paragraphs: [
          'The new Faea Kava represents a significant leap forward in production technique. The distillery developed a water-based kava extraction method followed by centrifuge filtration, resulting in a cleaner, more refined infusion that captures kava\'s subtle earthy character without any harsh notes.',
          'The habanero chillies are grown in the distiller\'s own garden, ensuring complete control over quality and freshness. A final vacuum distillation step extracts delicate floral notes from the botanical blend, adding complexity while maintaining balance.',
          'The result is a spirit that delivers gentle warmth from the chilli, an earthy depth from the kava, and the rich, tropical character of Vanuatu rum — all in perfect harmony.'
        ]
      },
      {
        heading: 'The Kava Experience',
        paragraphs: [
          'Kava holds deep cultural significance in Vanuatu and throughout the Pacific. The root has been used for centuries in ceremonial and social contexts, prized for its relaxing properties.',
          'For most people, the kava in Faea provides subtle earthy undertones that complement the rum\'s natural sweetness and the chilli\'s warmth. However, those familiar with traditional kava will recognise its distinctive presence — particularly if they allow the spirit to linger on the tongue, where the gentle numbing sensation from kava\'s active compounds becomes apparent.'
        ],
        quote: {
          text: 'Those who know kava will recognise its subtle presence, especially when you let Faea rest on your tongue for a moment. The gentle numbing sensation is the signature of this remarkable root.',
          attribution: '83 Islands Distillery'
        }
      },
      {
        heading: 'Important Considerations',
        paragraphs: [
          '83 Islands Distillery advises consumers to enjoy Faea Kava Spiced Rum responsibly. While the kava content is not enough to produce a strong effect on its own, combining alcohol and kava may increase intoxication and impairment. It may also elevate the risk of liver harm, particularly for heavy drinkers or those with pre-existing liver conditions.',
          'The spirit is best enjoyed slowly, either neat or on the rocks, to fully appreciate the complexity of flavours and the unique experience that only Faea can deliver.'
        ]
      },
      {
        heading: 'A World First from the Pacific',
        paragraphs: [
          'Faea Kava Spiced Rum represents more than just a new product — it\'s a celebration of Vanuatu\'s unique terroir and cultural heritage. By combining ingredients that could only come together in these islands, 83 Islands Distillery has created something genuinely unprecedented in the spirits world.',
          'The release is now available at the 83 Islands Distillery tasting bar in Port Vila and will be available through select retailers in Port Vila by the start of 2026.'
        ]
      }
    ],
    pressRelease: {
      forImmediateRelease: true,
      contactName: 'Pierre-Luc Chabot',
      contactEmail: 'contact@83islands.com',
      boilerplate: '83 Islands Distillery is Vanuatu\'s first craft rum distillery, founded in Port Vila. The distillery produces single-origin rum from Vanuatu\'s ancestral sugarcane varieties, grown in volcanic soil and harvested fresh for fermentation. Using traditional copper pot still distillation and tropical ageing, 83 Islands creates spirits that capture the true character of the Pacific islands.'
    }
  },
  {
    id: 'wellington-taste-of-vanuatu',
    title: '83 Islands Distillery Showcases the Tastes of Vanuatu in Wellington',
    publication: '83 Islands Distillery',
    date: '2025-11-03',
    author: '83 Islands Distillery',
    location: 'Wellington, New Zealand',
    heroImage: '/image/articles/83illustrationA-Web.jpg',
    lead: 'The Vanuatu High Commission in Wellington and 83 Islands Distillery jointly hosted a landmark event showcasing the Tastes of Vanuatu, featuring premium rum from 83 Islands Distillery and fine Vanuatu chocolate.',
    content: [
      {
        heading: '',
        paragraphs: [
          'The Vanuatu High Commission in Wellington and 83 Islands Distillery jointly hosted a landmark event showcasing the Tastes of Vanuatu, featuring premium rum from 83 Islands Distillery and fine Vanuatu chocolate from Gaston Chocolat, an Artisan Chocolate Maker based in Port Vila. This partnership event, hosted by His Excellency Jimmy Nipo, High Commissioner of the Republic of Vanuatu to New Zealand, marked the first official presentation of Vanuatu\'s rum and chocolate in New Zealand, bringing together representatives from government, trade, and the Ni-Vanuatu community alongside potential buyers and distributors.',
          'The evening was organised in collaboration with 83 Islands Distillery, founded in Port Vila, which produces single-origin rum made entirely from Vanuatu\'s ancestral sugarcane. Guests were invited to experience a guided tasting that paired 83 Islands\' rums with chocolate from Gaston Chocolat — highlighting the shared volcanic origin and tropical terroir of both products.'
        ],
        images: [
          {
            url: '/image/articles/wellington-tasting-1.jpg',
            alt: 'Guests at the Wellington event enjoying rum and chocolate pairing',
            caption: '83 Islands\'s Pierre-Luc Chabot guides the tasting by describing the products and their unique characteristics.'
          },
          {
            url: '/image/articles/wellington-event-venue.jpg',
            alt: 'Vanuatu High Commission event venue in Wellington',
            caption: 'The Tastes of Vanuatu event at the Vanuatu High Commission in Wellington, with guests from the diplomatic community of New Zealand and the Pacific Islands.'
          }
        ]
      },
      {
        heading: 'Strengthening Trade Links and Diaspora Engagement',
        paragraphs: [
          'The event drew a large turnout from the Ni-Vanuatu diaspora in New Zealand, reflecting both cultural pride and growing interest in products that represent Vanuatu\'s craftsmanship and agricultural heritage. It also offered an important platform for strengthening trade and distribution opportunities, with the 83 Islands team meeting several potential buyers and partners during the evening.'
        ],
        quote: {
          text: 'This presentation allowed us to connect directly with people who see real value in Vanuatu\'s story and the quality of what we produce. It reinforces our confidence as we work toward establishing formal distribution channels in New Zealand.',
          attribution: 'Pierre-Luc Chabot, Director of 83 Islands Distillery'
        },
        image: {
          url: '/image/articles/wellington-diaspora-community.jpg',
          alt: 'Ni-Vanuatu community members at the Wellington event',
          caption: 'The event brought together the Ni-Vanuatu diaspora in New Zealand, strengthening cultural connections.'
        }
      },
      {
        heading: 'New Packaging and Local Investment',
        paragraphs: [
          'During the event, 83 Islands unveiled its new packaging design, representing a major milestone in the company\'s expansion. The refreshed identity was created by Redfire, a design agency based in Auckland, with visual elements developed by a Ni-Vanuatu graphic designer and a Melanesian illustrator.',
          'The new labels will be printed in Wellington by Bluestar, with part of the production also taking place in Vanuatu, following a significant investment in the distillery\'s in-country printing capability. The initiative aims to reduce reliance on overseas suppliers while developing local skills and supporting the growth of creative industries in Vanuatu.',
          '83 Islands Distillery acknowledges the valuable partnership of Rob Cranna from Blue Star Ltd and Fraser Carson from Flightdec — trusted friends from New Zealand\'s private sector in Wellington whose support has been instrumental in bringing this event and project to fruition.'
        ],
        image: {
          url: '/image/articles/wellington-jimmy-nipo.jpg',
          alt: 'High Commissioner Jimmy Nipo at the Tastes of Vanuatu event',
          caption: 'High Commissioner Jimmy Nipo welcomes guests at this first-of-a-kind event jointly hosted by the Vanuatu High Commission and 83 Islands Distillery in Wellington.'
        }
      },
      {
        heading: 'A Showcase of Vanuatu\'s Spirit',
        paragraphs: [
          'Founded in Port Vila, 83 Islands Distillery crafts rum from Vanuatu\'s ancient sugarcane varieties, grown in volcanic soil and fermented within hours of harvest to capture their fresh, grassy character. Distillation takes place in copper stills, using only time, oak, and tropical climate to shape the final spirit — no added sugar or colouring.',
          'The distillery\'s rums are aged under tropical conditions, where high humidity and warm temperatures accelerate maturation, resulting in complex flavours in a shorter time. Each bottle tells a story of Vanuatu\'s resilience, natural abundance, and dedication to craftsmanship.'
        ],
        image: {
          url: '/image/TeoumaValley.jpg',
          alt: 'Sugarcane fields in Vanuatu',
          caption: 'Vanuatu\'s ancient sugarcane varieties, grown in volcanic soil, form the foundation of 83 Islands rum.'
        }
      },
      {
        heading: 'A Landmark Moment for Vanuatu Products',
        paragraphs: [
          'The Tastes of Vanuatu evening in Wellington stands as a milestone for both Vanuatu\'s food and beverage industry and its trade relations with New Zealand. It showcased how collaboration between local producers, designers, and the diaspora can elevate Pacific products on the international stage.',
          'As 83 Islands continues to expand its export reach, the company\'s focus remains clear: to ensure that the world not only visits Vanuatu — but tastes Vanuatu.'
        ],
        images: [
          {
            url: '/image/articles/wellington-event-group.jpg',
            alt: 'Group photo from the Tastes of Vanuatu event in Wellington',
            caption: 'The Tastes of Vanuatu event in Wellington - a landmark moment for Vanuatu products in New Zealand.'
          },
          {
            url: '/image/articles/wellington-event-hero.jpg',
            alt: 'The Tastes of Vanuatu event at the Vanuatu High Commission',
            caption: 'The inaugural Tastes of Vanuatu event showcasing premium rum and chocolate to New Zealand\'s diplomatic and trade communities.'
          }
        ]
      }
    ]
  }
]

// Function to get article by ID
export const getArticleById = (id) => {
  return articles.find(article => article.id === id)
}

// Function to get all articles
export const getAllArticles = () => {
  return articles
}
